import { render, staticRenderFns } from "./TwoFactorAuthenticationRecoveryCodesDialog.vue?vue&type=template&id=04137098&scoped=true"
import script from "./TwoFactorAuthenticationRecoveryCodesDialog.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationRecoveryCodesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04137098",
  null
  
)

export default component.exports